import React from 'react'
import {Row, Col, Form} from 'react-bootstrap'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'

interface SignatureFormSettingsProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormSettings: React.FC<SignatureFormSettingsProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className='form-settings'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            Signature Form Settings
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={6} className='mb-4'>
          <Form.Group>
            <Form.Label>
              Name {errors.name && <small className='text-danger'>{errors.name}</small>}
            </Form.Label>
            <Form.Control
              value={values.name}
              onChange={(e) => handleChange('name', e.target.value)}
              onBlur={() => handleBlur('name')}
              required
            />
          </Form.Group>
        </Col>

        <Col md={3} className='mb-5'>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={values.status}
              onChange={(e) => handleChange('status', e.target.value)}
            >
              <option value=''>Select one</option>
              <option value='ACTIVE'>Active</option>
              <option value='INACTIVE'>Inactive</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={3} className='mb-5'>
          <Form.Group>
            <Form.Label>Language</Form.Label>
            <Form.Select
              value={values.language}
              onChange={(e) => handleChange('language', e.target.value)}
            >
              <option value='es'>Español</option>
              <option value='en'>English</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col sm={12}>
          <Form.Group>
            <Form.Label>Descripcion</Form.Label>
            <Form.Control
              value={values.descripcion}
              onChange={(e) => handleChange('descripcion', e.target.value)}
              onBlur={() => handleBlur('descripcion')}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}
